export default __webpack_public_path__ + "a44583d14d6daf7fa70ae9762f608f3a.woff2";